import React from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { REDEEM_PATH } from '@/containers/Participant/GcmShared/routes';
const PointsClear = ({ pointBalance, template, program }) => {
  const { t } = useTranslation();
  const locale = new Intl.Locale('en-US');
  if (!pointBalance || !program) return t("loading");

  if (template?.name === "clear") {
    const redeemablePoints = Math.floor(pointBalance?.pointBalance ?? 0).toLocaleString(locale);
    const peerPoints = program.uses_peer2peer > 0
      ? (pointBalance.peerBalance * pointBalance.factor).toLocaleString(locale)
      : null;

    return (
      <div className="points-clear points-clear--compact">
        <div className="points-clear__headerline">
          <Link to="/participant/my-points" className="points-clear__eyebrow-link">
            {t("my_balance")}
          </Link>

          <Link to={REDEEM_PATH} className="points-clear__action">
            {t("redeem_my_points")}
          </Link>
        </div>

        <div className="points-clear__stat">
          <span className="points-clear__label">{t("points_to_redeem")}</span>
          <strong className="points-clear__amount">{redeemablePoints}</strong>
        </div>

        {peerPoints && (
          <div className="points-clear__meta">
            <span className="points-clear__meta-label">{t("peer_points_to_award")}</span>
            <strong className="points-clear__meta-value">{peerPoints}</strong>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={`points-${template.name} flex-column p-2`}>
      <div className={`points-${template.name}-header bg-blue rounded-3`}>
        <Link to="/participant/my-points" className="link text-white">{t("my_balance")}</Link>
      </div>
      <table className={`points-${template.name}-table`} width="100%">
        <tbody>
          <tr>
            <td className="points-title text-uppercase">
              {t("points_to_redeem")}:
            </td>
          </tr>
          <tr>
            <td className="value"> {Math.floor(pointBalance?.pointBalance ?? 0).toLocaleString(locale)}</td>
          </tr>
          {
            program.uses_peer2peer > 0 &&
            <>
              <tr>
                <td className="points-title text-uppercase">
                  {t("peer_points_to_award")}:
                </td>
              </tr>
              <tr>
              <td className="value"> {(pointBalance.peerBalance * pointBalance.factor).toLocaleString(locale)}</td>
              </tr>
            </>
          }
        </tbody>
      </table>
      <div className={`points-${template.name}-header bg-blue mt-3 rounded-3`}>
        <Link to={REDEEM_PATH} className="link text-white">{t("redeem_my_points")}</Link>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    pointBalance: state.pointBalance,
    template: state.template,
    program: state.program,
  };
};

export default connect(mapStateToProps)(PointsClear);
